import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface TemplateNameDialogData {
    template: string;
    fullsnapshot: boolean;
    disabled: boolean;
}

@Component({
    selector: 'dl-template-name-dialog',
    template: `
        <div mat-dialog-content>
          <p>Please enter template name</p>
          <mat-form-field appearance="fill">
            <mat-label>Template Name</mat-label>
            <input matInput [(ngModel)]="data.template">
          </mat-form-field>
        </div>
        <div>
            <mat-checkbox [(ngModel)]="data.fullsnapshot"
                          [disabled]="data.disabled">
              Full Snapshot
            </mat-checkbox>
        </div>
        <div mat-dialog-actions>
          <button mat-button (click)="onCancelClick()">CANCEL</button>
          <button mat-button [mat-dialog-close]="data" [disabled]="data.template== ''" >OK</button>
        </div>
    `,
    styles: [
        `
        div[mat-dialog-content] {
          padding: 20px;

        }
        `
    ]
})
export class TemplateNameDialogComponent {
    public static $name: string = 'templateNameDialog';

    constructor(
        private dialogRef: MatDialogRef<TemplateNameDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TemplateNameDialogData
    ) {
    }

    public onCancelClick() {
        this.data.template = '';
        this.dialogRef.close();
    }
}
